// Single, tasteful Pro Carer Circle promo used across Carer Essentials.
// Hidden entirely for members who already hold pro_carer (they already
// have everything Carer Essentials offers, plus more).
import { Link } from "react-router-dom";
import { Sparkles, ChevronRight } from "lucide-react";
import { useHandoverSession } from "../../hooks/useHandoverSession";

export default function PccUpgradePromo({ variant = "banner", text }) {
  const { entitlements } = useHandoverSession();
  if (entitlements.includes("pro_carer")) return null;

  if (variant === "contextual") {
    return (
      <div
        className="rounded-2xl border border-purple/15 bg-purple/5 p-5 flex items-start gap-3"
        data-testid="ce-pcc-promo-contextual"
      >
        <Sparkles className="w-5 h-5 text-purple shrink-0 mt-0.5" strokeWidth={1.75} />
        <div className="min-w-0">
          <p className="text-sm text-ink-muted leading-relaxed">
            {text || "Pro Carer Office members get everything in Carer Essentials, plus contracts, payment protection tools and more."}
          </p>
          <Link
            to="/pro-carer-circle"
            className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-purple hover:underline"
            data-testid="ce-pcc-promo-link"
          >
            Explore Pro Carer Office <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className="rounded-3xl border border-purple/15 bg-purple/5 p-7 md:p-8 flex flex-wrap items-center justify-between gap-5"
      data-testid="ce-pcc-promo-banner"
    >
      <div className="max-w-xl">
        <div className="overline text-purple mb-2">Go further</div>
        <h3 className="font-display text-lg md:text-xl font-semibold">
          Pro Carer Office includes Carer Essentials — plus much more
        </h3>
        <p className="mt-1.5 text-sm text-ink-muted leading-relaxed">
          Contracts &amp; agreements, payment protection, pricing tools, a full shift kit, and Care Discussion Rooms — all in one membership.
        </p>
      </div>
      <Link to="/pro-carer-circle" className="btn-purple shrink-0" data-testid="ce-pcc-promo-cta">
        Explore Pro Carer Office <ChevronRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
